import React, { useEffect, useState } from 'react'
import { useSearchParams, useLocation } from 'react-router-dom';
import routeParams from 'theme/routeParams';
import StatisticsCards from './statistics/StatisticsCards'
import { Column } from 'styled/alignment/Column'
import WithdrawList from './withdraw/WithdrawList'
import DeclinedTransactions from './declined-transactions/DeclinedTransactions'
import Divider from 'components/_UI/Divider'
import { useUser } from 'context/user/User'
import NotResultDashBoard from 'components/commons/NotResultDashBoard'
import paths from 'routes/paths'
import Loader from 'components/_UI/Loader'
import styled from 'styled-components'
import Text from 'components/_UI/Text'
import financialApi from 'api/requests/financial'
import DashCollapse from 'components/_UI/DashCollapse'
import Modal from 'components/_UI/Modal';
import BankForm from './bank-form/BankForm';
import InvoicesTable from './invoices/InvoicesTable';
import ToastContainer from 'components/_UI/ToastsContainer';
import useToast from 'hooks/useToast';
import establishmentsApi from 'api/requests/establishments';
import { useMyEstablishment } from 'context/establishments/MyEstablishment';
import { useWithdraw } from 'context/financial/Withdraw';
import ReceiptsCalendar from './calendar/ReceiptsCalendar';
import colors from 'theme/colors';
import { Row } from 'styled/alignment/Row';
import { FullyCentered } from 'styled/alignment/Center';
import { TrendingDown, TrendingUp } from 'react-feather';
import fonts from 'theme/fonts';
import FinancialStatusIcon from './status/FinancialStatusIcon';
import GeneralTransactions from './general/GeneralTransactions';
import GeneralView from './general/GeneralView';
import FinancialAnalysis from './analysis/FinancialAnalysis';
import breakpoints from 'theme/breakpoints';
import TransactionsList from './transactions/TransactionsList';


export default function Financial() {
    const { myEstablishment, setMyEstablishment } = useMyEstablishment();
    const { withdraw, setWithdraw } = useWithdraw();
    const { user } = useUser()
    const { toasts, toast } = useToast()
    const [searchParams, setSearchParams] = useSearchParams();
    const { search } = useLocation();

    const [isLoading, setIsLoading] = useState(true)
    const [data, setData] = useState(null)
    const [statementBalance, setStatementBalance] = useState(null)
    const [paginate, setPaginate] = useState(null)
    const [historyWithdraw, setHistoryWithdraw] = useState(null)
    const [notWithdraw, setNotWithdraw] = useState(false)
    const [showCollapse, setShowCollapse] = useState(false)
    const [showBankForm, setShowBankForm] = useState(false)
    const [showInvoices, setShowInvoices] = useState(false)
    // const [showCalendar, setShowCalendar] = useState(false)
    const [selectedTab, setSelectedTab] = useState('all');

    const tabKeys = {
        all: 'all',
        transactions: 'transactions',
        withdraw: 'withdraw',
        calendar: 'calendar',
        analysis: 'analysis',
    }

    const tabs = [
        { name: tabKeys.all, label: 'Visão geral' },
        { name: tabKeys.transactions, label: 'Transações' },
        { name: tabKeys.withdraw, label: 'Saques' },
        { name: tabKeys.calendar, label: 'Calendário' },
        { name: tabKeys.analysis, label: 'Análises' },
    ];



    const closeCollapse = () => {
        setSearchParams((prevSearchParams) => {
            const newSearchParams = new URLSearchParams(prevSearchParams);

            Object.values(routeParams.financial).map(el => {
                newSearchParams.delete(el)
            })

            return newSearchParams;
        });
    }

    function loadData() {
        Promise.all([
            getFinancial(),
            getEstablishments(),
            getWithdrawData(),
        ]).then(() => {
            setIsLoading(false)
        })
    }

    async function getFinancial() {
        try {
            const { data } = await financialApi.get()
            setData(data)
            setWithdraw({
                ...withdraw,
                availableValue: data?.balance_available
            })
        } catch (error) {

        }
    }

    async function getStatementBalance() {
        try {
            const { data } = await financialApi.getStatementBalanceWithLimit();
            setStatementBalance(data?.data);
        } catch (error) {

        }
    }

    async function getWithdrawData(number = 1) {
        try {
            // const { data } = await financialApi.getWithdrawData({ page: number })
            const { data } = await financialApi.getWithdrawDataWithLimit()
            setPaginate(data)
            setHistoryWithdraw({
                ...historyWithdraw,
                data: data
            })


            if (data?.data?.length == 0) {
                setNotWithdraw(true)

            }
        } catch (error) {

        }
    }

    async function getEstablishments() {
        if (myEstablishment?.length) {
            return
        }

        try {
            const { data } = await establishmentsApi.my()
            setMyEstablishment(data?.data)
            validateBankFormCollapse(data?.data)
        } catch (error) {

        }
    }

    function validateBankFormCollapse(establishments) {
        if (showBankForm && !establishments?.length) {
            setShowBankForm(false)
            closeCollapse()
        }
    }

    useEffect(() => {
        const bankParam = searchParams.get(routeParams.financial.bank)
        const invoicesParam = searchParams.get(routeParams.financial.invoices)
        // const calendarParams = searchParams.get(routeParams.financial.calendar)

        setShowBankForm(!!bankParam);
        setShowInvoices(!!invoicesParam);
        // setShowCalendar(!!calendarParams)
        setShowCollapse(!!invoicesParam)
    }, [search]);

    useEffect(() => {
        setIsLoading(true)
        getStatementBalance();
        loadData();

    }, [withdraw?.success]);



    function onChangeTab(tabName) {
        setSelectedTab(tabName)
    }

    return (
        <>
            <ToastContainer toasts={toasts} />


            <Column>
                {
                    !isLoading ? (

                        !user?.establishments?.length && user?.role?.id == import.meta.env.VITE_ESTABLISHMENT_ROLE_ID ? (
                            <NotResultDashBoard
                                ilustration={'profile'}
                                text={'Notei que você ainda não possuí seu estabelecimento. Que tal criar seu estabelecimento?'}
                                textButton={'Criar meu estabelecimento'}
                                path={`${paths.dashboard.home}?create=1`}
                            />
                        ) : (
                            <>
                                <StatisticsCards data={data} />

                                <Tabs>
                                    {tabs.map(el => (
                                        <TabItem
                                            key={el.name}
                                            selected={el.name === selectedTab}
                                            onClick={() => onChangeTab(el.name)}
                                        >
                                            {el.label}
                                        </TabItem>
                                    ))}
                                </Tabs>

                                {
                                    selectedTab === tabKeys.all && (
                                        <GeneralView
                                            statementBalance={statementBalance}
                                            withdraw={historyWithdraw?.data?.data}
                                            onStatementBalanceSeeAllClick={() => onChangeTab(tabKeys.transactions)}
                                            onSeeAllWithdrawClick={() => onChangeTab(tabKeys.withdraw)}
                                        />
                                    )
                                }

                                {
                                    selectedTab === tabKeys.withdraw && (
                                        historyWithdraw?.data?.data?.length > 0 ? (
                                            <WithdrawList
                                                data={historyWithdraw}
                                                currentPage={paginate?.current_page}
                                                totalItems={paginate?.total}
                                                lastPage={paginate?.last_page}
                                                firstPage={paginate?.first_page}
                                                perPage={paginate?.per_page}
                                                onPaginate={(number) => getWithdrawData(number)}
                                            />
                                        ) : (
                                            notWithdraw &&
                                            <NotResultDashBoard
                                                text={
                                                    <>
                                                        <Text name='subtitle'>Históricos de saques</Text>
                                                        <Text>Parece que você ainda não efetuou nenhum saque.</Text>
                                                        <Text marginTop={'5px'}>Verifique se possui algum valor a receber disponivel e faça o primeiro repasse para sua conta bancaria.</Text>
                                                    </>
                                                }
                                                ilustration={'withdraw'}
                                                marginTop={'15px'}
                                            />
                                        )
                                    )
                                }

                                {
                                    selectedTab === tabKeys.transactions && (
                                        <TransactionsList />
                                    )
                                }

                                {
                                    selectedTab === tabKeys.calendar && (
                                        <ReceiptsCalendar />
                                    )
                                }

                                {
                                    selectedTab === tabKeys.analysis && (
                                        <FinancialAnalysis />
                                    )
                                }

                            </>
                        )
                    ) : (
                        <Loader />
                    )
                }
            </Column>

            {/* <Divider marginTop={'40px'} marginBottom={'0'} opacity={.4} /> */}
            {/* <DeclinedTransactions /> */}

            <Modal
                isOpen={showBankForm}
                onClose={closeCollapse}
                closeButton
                size='large'
                childrenOverflowY='scroll'
            >
                <BankForm visible={showBankForm} onClose={closeCollapse} toast={toast} />
            </Modal>

            <DashCollapse visible={showCollapse} onClose={() => closeCollapse()}>
                {
                    showInvoices && <InvoicesTable closeCollapse={closeCollapse} toast={toast}></InvoicesTable>
                }
            </DashCollapse>
        </>
    )
}


const Tabs = styled(Row)`
    margin-top: 20px;
    box-shadow: 0 0 4px #eee;
    border-radius: 6px;
    padding: 4px;
    background-color: ${colors.neutralLight};
    overflow: auto;
    `;

const TabItem = styled.div`
    padding: 8px 14px;
    cursor: pointer;
    transition: border-bottom 0.2s ease-in-out;
    width: 100%;
    text-align: center;

    &:first-child {
        padding-left: 10px;
    }

    ${({ selected }) => selected && `
        background: #F3E8FF;
        color: ${colors.secondaryPurple};
        border-radius: 6px;
    `};
`;
